import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OeAppService } from './oe-app.service';
import { RequireAdapterService } from './require-adapter.service';
import { Store } from './store';
import { LanguageInfoDto } from './types/LanguageInfoDto';

declare var window: any;

@Injectable()
export class TranslationService extends Store<LanguageInfoDto[]> {
  private i18n: any;

  constructor(private readonly requireAdapter: RequireAdapterService, oeAppService: OeAppService) {
    super(oeAppService.supportedLanguages());
    this.i18n = this.requireAdapter.loadI18N();
  }

  translate(key: string, data?: any, languageCodeOverride?: string) {
    return (this.i18n.get && this.i18n.get(key, data, null, languageCodeOverride)) || this.i18n[key] || key;
  }

  get supportedLanguages$() {
    return this.state$;
  }

  getCurrentLanguage() {
    return window.commonConfig.getNLSLanguage();
  }

  getLanguageDescriptions(): Observable<LanguageInfoDto[]> {
    return this.state$;
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/translation.service.ts